import { get } from 'lodash';
import { AUDIO_TYPE, VIDEO_TYPE, IMAGE_TYPE } from '../../MediaViewer/consts';

const walkthroughStep1 = (fileType, i18n) => ({
    element: '#collaboration-comment-box',
    popover: {
        description: `<div class="collaboration-add-comments-intro">
            <i class="icn-section icn-add-comment"></i>
            <div class="content-wrapper">
                <b>${i18n.t('attachments_preview.walkthrough.add_your_comments_here')}</b><br />
                ${[VIDEO_TYPE, AUDIO_TYPE].indexOf(fileType) > -1 ? `<span>${i18n.t('attachments_preview.walkthrough.timestamp_will_be_included')}</span>` : ''}
            </div>
        </div>`,
        position: 'left-center'
    }
});

const walkthroughStep2 = (fileType, i18n) => {
    if ([VIDEO_TYPE, IMAGE_TYPE].indexOf(fileType) > -1) {
        return {
            element: '.media-overlay',
            popover: {
                className: 'annotations-wrapper',
                description: `<div class="collaboration-new-comment-intro">
                    <i class="icn-section icn-annotation"></i>
                    <div class="content-wrapper">
                        <span>${i18n.t('attachments_preview.walkthrough.click_directly_on_file')}</span>
                    </div>
                </div>`,
                position: 'right-center'
            }
        };
    }
};

const walkthroughStep3 = (othersCommentsLength, i18n) => (othersCommentsLength && {
    element: '.others-comment',
    popover: {
        description: `<div class="collaboration-new-comment-intro">
            <i class="icn-section icn-reply-to-comment"></i>
            <div class="content-wrapper">
                <b>${i18n.t('attachments_preview.walkthrough.you_have_new_comment')}</b><br />
                <span>${i18n.t('attachments_preview.walkthrough.click_reply_to_respond')}</span>
            </div>
        </div>`,
        position: 'left-center'
    }
});

const walkthroughStep4 = (i18n) => ({
    element: '.submit-all-btn',
    popover: {
        className: 'submit-all-btn',
        description: `<div class="collaboration-submit-reviews-intro">
            <i class="icn-section icn-submit-comment"></i>
            <div class="content-wrapper">
                ${i18n.t('attachments_preview.walkthrough.dont_forget_to_click')}
                <b>${i18n.t('attachments_preview.walkthrough.submit_all_comments')}</b>
                ${i18n.t('attachments_preview.walkthrough.to_leave_your_feedback')}
            </div>
        </div>`,
        position: 'top-right'
    }
});

const walkthroughStep5 = (collaboratorPermissions, i18n) => {
    if (get(collaboratorPermissions, 'invite')) {
        return {
            element: '.invite-btn',
            popover: {
                description: `<div class="collaboration-invite-btn-intro">
                    <i class="icn-section icn-invite-btn"></i>
                    <div class="content-wrapper">
                        <header>
                            <b>${i18n.t('attachments_preview.walkthrough.invite_collaborators')}</b>
                            <i class="icn-new-badge">${i18n.t('attachments_preview.walkthrough.new')}</i>
                        </header>
                        <span>${i18n.t('attachments_preview.walkthrough.invite_content')}</span>
                    </div>
                </div>`,
                position: 'bottom-right'
            }
        };
    }
};

const walkthroughStep6 = (groupsCount, i18n) => {
    if (groupsCount >= 2) {
        return {
            element: '.groups-tabs',
            popover: {
                className: 'groups-tabs-wrapper',
                description: `<div class="collaboration-groups-tabs-intro">
                    <i class="icn-section icn-groups-tabs"></i>
                    <div class="content-wrapper">
                        <span>${i18n.t('attachments_preview.walkthrough.groups_tabs')}</span>
                    </div>
                </div>`,
                position: 'bottom-right'
            }
        };
    }
};

export default function getSteps(fileType, othersCommentsLength, collaboratorPermissions, groupsCount, i18n) {
    return [
        walkthroughStep1(fileType, i18n),
        walkthroughStep2(fileType, i18n),
        walkthroughStep3(othersCommentsLength, i18n),
        walkthroughStep4(i18n),
        walkthroughStep5(collaboratorPermissions, i18n),
        walkthroughStep6(groupsCount, i18n)
    ].filter((s) => s);
}
